import { DateRangeEnd } from '../enums';
import { TFunction } from 'i18next';

/**
 * Get the text for the month option based on the date range end.
 */
export const getMonthTextFromDateRangeEnd = (
  dateRangeEnd: DateRangeEnd,
  t: TFunction
) => {
  switch (dateRangeEnd) {
    case DateRangeEnd.start:
      return t('datePickerMonthStart', {
        defaultValue: 'Start of the month',
        ns: 'search',
      });
    case DateRangeEnd.end:
      return t('datePickerMonthEnd', {
        defaultValue: 'End of the month',
        ns: 'search',
      });
    default:
      return '';
  }
};
